import React, { useState, useEffect } from 'react'
import label from '../../../../../../assets/i18n/en.json'
import PracticeLocationSelector from '../../../../templates/components/PracticeLocationSelector'

const PracticeLocationRoomForm = (props) => {
    const { initialFormData, submitHandler } = props
    const [locationData, setLocationData] = useState(props.initialFormData)

    const inputChange = (e) => {
        let newStateObject = { ...locationData };
        newStateObject[e.target.name] = e.target.value
        setLocationData(newStateObject);
        return console.log(locationData)
    }

    return (
        <div className="ui container">
            <div className="row d-flex ">
                <div className="field col-12">
                <label>Practice Location</label>
                <PracticeLocationSelector locationId={locationData?.practiceLocationId ? locationData?.practiceLocationId : null} disabled={props.initialFormData?.practiceLocationId ? true : false} dontResetState={true}/>
                </div>
            </div>
            <div className="row d-flex ">
                <div className="field col-12">
                    <label>Practice Location Room</label>
                    <input
                        placeholder='Practice Location Room'
                        type='text'
                        name="room"
                        value={locationData?.room}
                        onChange={(e) => {e.preventDefault(); inputChange(e)}}
                    />
                </div>
            </div>
            <div className='mt-3 d-flex justify-content-between modal-button-bar'>
                
                <div className='col-auto'>
                    <button className="btn btn-primary" onClick={(e) => { e.preventDefault(); submitHandler(locationData) }}>{label.user.add.save}</button>
                </div>
                <div className='col-auto'>
                    <button className='btn btn-secondary' onClick={e => { e.preventDefault(); if (props.onClose()) { props.onClose() } }}>Close</button>
                </div>
            </div>
        </div>
    )
}

export default PracticeLocationRoomForm